import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { AssessmentGroup } from '../../shared/models/assessment-group';
import { Assessment } from '../../shared/models/assessment';
import { AssessmentGroupService } from '../../shared/services/assessment-group.service';
import { AssessmentTokenService } from '../../shared/services/assessment-token.service';
import { AlertService } from '../../shared/services/alert.service';

class AssessmentGroupDisplay extends AssessmentGroup {
  Show:boolean;
  ShowAdd:boolean;
  constructor() {
    super();
    this.ShowAdd = false;
    this.Show = false;
  }
}
@Component({
  selector: 'app-assessment-group-edit',
  templateUrl: './assessment-group-edit.component.html',
  styleUrls: ['./assessment-group-edit.component.css']
})
export class AssessmentGroupEditComponent implements OnInit {

  public NewGroupName:string;
  public showGroups:boolean;

  private groups:AssessmentGroupDisplay[];

  private assessments:Assessment[];
  private showAdd:boolean = false;
  public hasLoaded:boolean;

  constructor(
    private assessmentGroupService:AssessmentGroupService
    ,private assessmentTokenService:AssessmentTokenService
    ,private alertService:AlertService
  ) { 
    this.groups = [];
    this.showGroups = false;
  }

  ngOnInit() {
    this.loadGroups();
  }

  loadGroups() {
    this.hasLoaded = false;
    let showAllGroups = this.showGroups;
    Promise.all([this.assessmentTokenService.loadAssessmentTokens(), this.assessmentGroupService.getAssessmentGroups(showAllGroups)])
    .then((results) => {
      this.hasLoaded = true;
      let groups:AssessmentGroup[] = results[1];
      // add a display property so we can expand/contract it.
      this.groups = groups.map((g) => {
        let displayGroup = new AssessmentGroupDisplay();
        Object.assign(displayGroup, g);
        displayGroup.Show = false;
        return displayGroup;
      })
    })
    .catch((error) => {
      console.error(error);
      this.alertService.error("Check your internet connection.  Failed to load data");
    });
  }

  reloadGroups(event:Event) {
    this.showGroups = !this.showGroups;
    event.preventDefault();
    event.stopImmediatePropagation();
    this.loadGroups();
  }

  getTokensRemaining(group:AssessmentGroupDisplay) {
    if (!group) {
      return 0;
    }
    
    return this.assessmentTokenService.getGroupRemainingTokens(group);
  }

  toggleGroup(group:AssessmentGroupDisplay) {
    group.Show = !group.Show;
    console.log(group, group.Show);
  }

  updateAssessmentVersions(group:AssessmentGroupDisplay , event:Event) {
    event.stopImmediatePropagation();
    let info = this.alertService.info("Updating assessment versions", 30000);
    this.assessmentGroupService.updateAssessmentsForGroup(group)
    .then(updatedGroup => {
      this.alertService.clearAlert(info);
      let index = this.groups.findIndex(g => g == group);
      let displayGroup = new AssessmentGroupDisplay();
      Object.assign(displayGroup, updatedGroup);
      displayGroup.Show = group.Show;
      this.groups[index] = displayGroup;
      this.alertService.success("Assessment versions updated");
    })
    .catch((error) => {
      console.error(error);
      this.alertService.clearAlert(info);
      this.alertService.error("There was an error in updating the assessments for this group.  Check the server logs");
    });
  }

  addAssessmentToGroup(group:AssessmentGroup, assessment:Assessment) {
    let dup = group.Assessments.find((a) => {return a.uid == assessment.uid });
    if (dup) {
      alert("This assessment already has been added.");
      return;
    }

    group.Assessments.push(assessment);
    this.assessmentGroupService.addAssessmentToGroup(group, assessment).then((assessment:Assessment) => {
      assessment.version = assessment.version;
      assessment.id = assessment.id;
    })
    .catch((error) => {
      console.error(error);
      // TODO: stephen need to display an error here...
      // remove it
      let index = group.Assessments.indexOf(assessment);
      if (index >= 0) {
        group.Assessments.splice(index, 1);
      }
    });
  }

  addGroupFromKeypress(event) {
    // enter key is 13
    if (!event || event.charCode !== 13) {
      return;
    }
    this.addGroup();
  }

  addGroup() {
    this.assessmentGroupService.createNewGroup(this.NewGroupName).then((group:AssessmentGroup) => {
      let display = new AssessmentGroupDisplay();
      Object.assign(display, group);

      // hide all the others, and show the one we just added.
      this.groups.forEach((g) => g.Show = false);
      display.Show = true;
      display.ShowAdd = true;
      this.NewGroupName = "";

      this.groups.push(display);
    });
  }

  public get Groups() {
    return this.groups;
  }

  public toggleShowAdd(group:AssessmentGroupDisplay, event:Event) {
    event.stopImmediatePropagation();
    group.ShowAdd = !group.ShowAdd;
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/assessment-group-edit/assessment-group-edit.component.ts